<ng-container
  *ngIf="{
    isActived: isActived$ | async,
  } as content"
>
  <button
    type="button"
    class="container-hamburguer"
    [ngClass]="{ active: content.isActived }" 
    (click)="toggleStatus()"
    aria-label="Open menu"
  >
    <span></span>
    <span></span>
    <span></span>
  </button>
</ng-container>
